import { render, staticRenderFns } from "./addProduction.vue?vue&type=template&id=87c3a54e&scoped=true&"
import script from "./addProduction.vue?vue&type=script&lang=js&"
export * from "./addProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c3a54e",
  null
  
)

export default component.exports